(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3292],{

/***/ 34847:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/faq/[id]",
      function () {
        return __webpack_require__(76201);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ FAQ_LOG_EVENT; }
/* harmony export */ });
var FAQ_LOG_EVENT = {
    CLICK_FAQ_TOC: "click_faq_toc",
    CLICK_FAQ_TAG: "click_faq_tag",
    UPPER_FAQ_SHARE_CLICK: "upper_faq_share_click",
    DETAIL_STICKY_BUTTON_CLICK: "faq_detail_sticky_button_click",
    FAQ_RELATED_QNA_CLICK: "faq_related_qna_click",
    FAQ_RELATED_BOARD_POST_CLICK: "faq_related_board_post_click",
    CLICK_OUTER_LINK: "click_outer_link"
};


/***/ }),

/***/ 76201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "createFaqLdJson": function() { return /* binding */ createFaqLdJson; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 90 modules
var react_markdown = __webpack_require__(91650);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/components/atom/TagList.tsx
var TagList = __webpack_require__(20254);
// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
// EXTERNAL MODULE: ./src/components/common/communication/ContentBottom.tsx + 6 modules
var ContentBottom = __webpack_require__(48271);
// EXTERNAL MODULE: ./src/components/common/communication/ContentRelatedQna.tsx
var ContentRelatedQna = __webpack_require__(24412);
// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
// EXTERNAL MODULE: ./src/components/common/markdown-toc/index.tsx
var markdown_toc = __webpack_require__(52138);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/templates/communication/magazine/magazine-detail-template/index.tsx + 6 modules
var magazine_detail_template = __webpack_require__(41066);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
;// CONCATENATED MODULE: ./src/components/templates/communication/faq/faq-detail-template/faq-sticky-button/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    div + div {\n        margin: 0;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FaqStickyButton = function(param) {
    var faq = param.faq, bottomButtonText = param.bottomButtonText, onClickButton = param.onClickButton, shouldShowEventText = param.shouldShowEventText;
    var EventContent = function() {
        switch(faq.bottomButtonType){
            case magazine/* MagazineBottomButtonType.DIAGNOSIS */.wK.DIAGNOSIS:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            case magazine/* MagazineBottomButtonType.QUESTION */.wK.QUESTION:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_template/* StickyButtonWrapper */.Ny, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyArea, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default.Button */.Z.Button, {
                    textAsH2: true,
                    text: bottomButtonText,
                    onClick: onClickButton
                }),
                shouldShowEventText && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventContent, {})
            ]
        })
    });
};
/* harmony default export */ var faq_sticky_button = (FaqStickyButton);
var StickyArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68061309-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/components/templates/communication/magazine/magazine-detail-template/magazine-detail-tags/index.tsx
var magazine_detail_tags = __webpack_require__(61099);
// EXTERNAL MODULE: ./src/components/templates/communication/magazine/magazine-detail-template/related-magazine-list/index.tsx
var related_magazine_list = __webpack_require__(25761);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/magazine/MagazineDetailSkeleton.tsx
var MagazineDetailSkeleton = __webpack_require__(34759);
// EXTERNAL MODULE: ./src/constants/logs/deeplink/index.ts
var deeplink = __webpack_require__(60643);
// EXTERNAL MODULE: ./src/constants/logs/magazine/index.ts
var logs_magazine = __webpack_require__(72563);
// EXTERNAL MODULE: ./src/entities/diagnosis/index.ts + 5 modules
var diagnosis = __webpack_require__(63507);
// EXTERNAL MODULE: ./src/entities/diagnosis/libs/constants.ts
var constants = __webpack_require__(36444);
// EXTERNAL MODULE: ./src/models/ad/list.ts
var list = __webpack_require__(70847);
// EXTERNAL MODULE: ./src/shared/ui/index.ts + 23 modules
var ui = __webpack_require__(75525);
// EXTERNAL MODULE: ./src/shared/ui/content-mark-down/ContentMarkDown.tsx
var ContentMarkDown = __webpack_require__(26324);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
// EXTERNAL MODULE: ./src/utils/style.ts + 1 modules
var style = __webpack_require__(13195);
;// CONCATENATED MODULE: ./src/components/templates/communication/faq/faq-detail-template/index.tsx



function faq_detail_template_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 8px 24px 32px 24px;\n\n  hgroup {\n    display: flex;\n    flex-direction: column;\n    word-break: keep-all;\n    width: 100%;\n    padding-right: 24px;\n    white-space: pre-wrap;\n  }\n\n  h1 {\n    ",
        ";\n    line-height: 36px;\n    color: ",
        ";\n    margin-bottom: 8px;\n    word-break: keep-all;\n  }\n\n  h2 {\n    width: fit-content;\n    word-break: keep-all;\n    ",
        ";\n    color: ",
        ";\n    margin-bottom: 8px;\n  }\n\n  time {\n    ",
        ";\n    color: ",
        ";\n\n    svg {\n      margin: 0 8px;\n    }\n  }\n"
    ]);
    faq_detail_template_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
































var FaqDetailTemplate = function(param) {
    var viewModel = param.viewModel, topBannerViewModel = param.topBannerViewModel, client = param.client;
    if (!viewModel.faq) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineDetailSkeleton/* default */.Z, {});
    }
    var _createdAt, _magazinePid, _magazinePid1, _magazinePid2, _footnote, _magazinePid3, _title, _description, _prevFaqPid, _nextFaqPid;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                    title: "1분 FAQ"
                })
            }),
            topBannerViewModel.isNewAdVisibleClient(client) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                style: {
                    top: 60
                },
                isVisible: topBannerViewModel.isScrollVisible,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UnifiedAdBanner */.g7, {
                    adPageType: list/* AdPageType.TopCommonBanner */.hO.TopCommonBanner,
                    client: client,
                    fallbackContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* GoogleAdSense */.Bi, {
                        client: client,
                        adPageType: list/* AdPageType.TopCommonBanner */.hO.TopCommonBanner,
                        wrapperClassName: (0,style.cn)("h-[50px] flex w-full items-center justify-center bg-white"),
                        style: {
                            width: 320,
                            height: 50
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_template/* Background */.Aq, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                    children: [
                        client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_template/* BreadCrumbsWrapper */.XQ, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                                visible: true,
                                name: viewModel.faq.title,
                                path: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(viewModel.faq.title),
                                urlParameter: viewModel.faq.magazinePid,
                                type: "magazine"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(magazine_detail_template/* Wrapper */.im, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("hgroup", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                children: viewModel.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: viewModel.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                dateTime: (0,format/* absoluteTime */.wE)((_createdAt = viewModel.faq.createdAt) !== null && _createdAt !== void 0 ? _createdAt : dayjs_min_default()().date()),
                                                children: dayjs_min_default()(viewModel.faq.createdAt).format("YYYY.MM.DD")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(magazine_detail_template/* Content */.VY, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_template/* MarkDown */.sd, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentMarkDown/* default */.Z, {
                                                markdown: viewModel.faqContent,
                                                components: {
                                                    h2: function(node) {
                                                        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                            rest[_key - 1] = arguments[_key];
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            id: "".concat(node.children)
                                                        }, rest), {
                                                            children: node.children
                                                        }));
                                                    },
                                                    h3: function(node) {
                                                        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                            rest[_key - 1] = arguments[_key];
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            id: "".concat(node.children)
                                                        }, rest), {
                                                            children: node.children
                                                        }));
                                                    },
                                                    h4: function(node) {
                                                        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                            rest[_key - 1] = arguments[_key];
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            id: "".concat(node.children)
                                                        }, rest), {
                                                            children: node.children
                                                        }));
                                                    },
                                                    div: function(node) {
                                                        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                            rest[_key - 1] = arguments[_key];
                                                        }
                                                        if (node.className === "toc") {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                id: "toc"
                                                            }, rest), {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown_toc/* default */.Z, {
                                                                    content: viewModel.faqContent,
                                                                    magazineTocLogger: viewModel.magazineTocLogger
                                                                })
                                                            }));
                                                        }
                                                        if (node.className === "cta5" || node.className === "cta4") {
                                                            var cta5 = node.children[1];
                                                            var _props = cta5.props, name = _props.name, value = _props.value, children = _props.children;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                className: node.className
                                                            }, rest), {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    name: name,
                                                                    onClick: function() {
                                                                        return viewModel.moveToHospital(value);
                                                                    },
                                                                    children: children
                                                                })
                                                            }));
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            className: node.className
                                                        }, rest), {
                                                            children: node.children
                                                        }));
                                                    },
                                                    a: function(node) {
                                                        var ref, ref1;
                                                        if ((ref = node.href) === null || ref === void 0 ? void 0 : ref.includes("https://abr.ge")) {
                                                            var ref2;
                                                            var ref3, _href, _sub_id, _sub_id_1, _sub_id_2, _sub_id_3;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                                                params: {
                                                                    eventName: deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton,
                                                                    payload: {
                                                                        magazinePid: (ref3 = (ref2 = viewModel.faq) === null || ref2 === void 0 ? void 0 : ref2.magazinePid) !== null && ref3 !== void 0 ? ref3 : "",
                                                                        linkUrl: (_href = node.href) !== null && _href !== void 0 ? _href : "",
                                                                        ab_term: viewModel.extractTextFromChildren(node.children),
                                                                        ab_campaign: "web_content_faq",
                                                                        ab_content: "web_content_btn_details",
                                                                        ab_sub_id: (_sub_id = viewModel.airbridgeLinkOptions.sub_id) !== null && _sub_id !== void 0 ? _sub_id : "",
                                                                        ab_sub_id_1: (_sub_id_1 = viewModel.airbridgeLinkOptions.sub_id_1) !== null && _sub_id_1 !== void 0 ? _sub_id_1 : "",
                                                                        ab_sub_id_2: (_sub_id_2 = viewModel.airbridgeLinkOptions.sub_id_2) !== null && _sub_id_2 !== void 0 ? _sub_id_2 : "",
                                                                        ab_sub_id_3: (_sub_id_3 = viewModel.airbridgeLinkOptions.sub_id_3) !== null && _sub_id_3 !== void 0 ? _sub_id_3 : ""
                                                                    }
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                                                    href: viewModel.getAirbridgeDynamicLink((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, viewModel.airbridgeLinkOptions), {
                                                                        campaign: "web_content_faq",
                                                                        content: "web_content_btn_details",
                                                                        term: viewModel.extractTextFromChildren(node.children)
                                                                    })),
                                                                    onClickNavigateToScreen: function() {
                                                                        return viewModel.onClickOuterLinkWithLinkText(viewModel.getAirbridgeDynamicLink((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, viewModel.airbridgeLinkOptions), {
                                                                            campaign: "web_content_faq",
                                                                            content: "web_content_btn_details",
                                                                            term: viewModel.extractTextFromChildren(node.children)
                                                                        })));
                                                                    },
                                                                    target: "_blank",
                                                                    className: "markdown-link",
                                                                    wrapperStyle: {
                                                                        display: "inline-block"
                                                                    },
                                                                    children: node.children
                                                                })
                                                            });
                                                        }
                                                        var ref4, _href1, _href2, _href3;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                                            params: {
                                                                eventName: logs_magazine/* MAGAZINE_LOG_EVENT.CLICK_OUTER_LINK */.W.CLICK_OUTER_LINK,
                                                                payload: {
                                                                    magazinePid: (ref4 = (ref1 = viewModel.faq) === null || ref1 === void 0 ? void 0 : ref1.magazinePid) !== null && ref4 !== void 0 ? ref4 : "",
                                                                    linkUrl: (_href1 = node.href) !== null && _href1 !== void 0 ? _href1 : "",
                                                                    linkText: viewModel.extractTextFromChildren(node.children)
                                                                }
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                                                href: (_href2 = node.href) !== null && _href2 !== void 0 ? _href2 : "",
                                                                onClickNavigateToScreen: function() {
                                                                    return viewModel.onClickOuterLinkWithLinkText((_href3 = node.href) !== null && _href3 !== void 0 ? _href3 : "");
                                                                },
                                                                target: "_blank",
                                                                className: "markdown-link",
                                                                wrapperStyle: {
                                                                    display: "inline-block"
                                                                },
                                                                children: node.children
                                                            })
                                                        });
                                                    }
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(magazine_detail_template/* MagazineTagsWrapper */.dU, {
                                            children: [
                                                viewModel.diseaseTags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_tags/* default */.Z, {
                                                    title: "관련 질병 알아보기",
                                                    magazinePid: (_magazinePid = viewModel.faq.magazinePid) !== null && _magazinePid !== void 0 ? _magazinePid : "",
                                                    tags: viewModel.diseaseTags,
                                                    onClick: viewModel.moveToTotalSearch
                                                }),
                                                viewModel.symptomTags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_tags/* default */.Z, {
                                                    title: "관련 증상 알아보기",
                                                    magazinePid: (_magazinePid1 = viewModel.faq.magazinePid) !== null && _magazinePid1 !== void 0 ? _magazinePid1 : "",
                                                    tags: viewModel.symptomTags,
                                                    onClick: viewModel.moveToTotalSearch
                                                }),
                                                viewModel.departmentTags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_tags/* default */.Z, {
                                                    title: "관련 진료 병원 찾기",
                                                    magazinePid: (_magazinePid2 = viewModel.faq.magazinePid) !== null && _magazinePid2 !== void 0 ? _magazinePid2 : "",
                                                    tags: viewModel.departmentTags,
                                                    onClick: viewModel.moveToHospital
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_template/* FootNote */.Ob, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                                children: (_footnote = viewModel.faq.footnote) !== null && _footnote !== void 0 ? _footnote : ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_template/* TagWrapper */.nf, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagList/* default */.Z, {
                                                tags: viewModel.faqTagNames.map(function(tag) {
                                                    return tag;
                                                }),
                                                padding: [
                                                    8,
                                                    16
                                                ],
                                                onClickTagName: viewModel.onClickTag
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_template/* Bottom */.z, {
                                            isLiked: viewModel.faq.isLikedByMe,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBottom/* default */.Z, {
                                                onClickLike: viewModel.onClickLike,
                                                isLikedByMe: viewModel.faq.isLikedByMe,
                                                likeCount: viewModel.faq.likeCount,
                                                copyUrl: viewModel.copyUrl,
                                                onClickLog: viewModel.onClickShare,
                                                id: (_magazinePid3 = viewModel.faq.magazinePid) !== null && _magazinePid3 !== void 0 ? _magazinePid3 : "",
                                                title: (_title = viewModel.faq.title) !== null && _title !== void 0 ? _title : "",
                                                description: (_description = viewModel.faq.description) !== null && _description !== void 0 ? _description : "",
                                                titleImageUrl: "".concat("https://media.doctornow.co.kr/og-magazine.png"),
                                                onRecordLog: viewModel.onRecordLog
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(magazine_detail_template/* NavigatorWrapper */.Cu, {
                                            children: [
                                                viewModel.prevFaqPid && /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                                    href: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(viewModel.prevFaqPid),
                                                    onClickNavigateToScreen: function() {
                                                        return viewModel.onClickPrevNextFaq((_prevFaqPid = viewModel.prevFaqPid) !== null && _prevFaqPid !== void 0 ? _prevFaqPid : "");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(magazine_detail_template/* PrevNavigator */.Tl, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                                name: "arrow_back",
                                                                size: 16,
                                                                color: theme/* default.color.gray600 */.Z.color.gray600
                                                            }),
                                                            "이전 글"
                                                        ]
                                                    })
                                                }),
                                                viewModel.nextFaqPid && /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                                    href: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(viewModel.nextFaqPid),
                                                    onClickNavigateToScreen: function() {
                                                        return viewModel.onClickPrevNextFaq((_nextFaqPid = viewModel.nextFaqPid) !== null && _nextFaqPid !== void 0 ? _nextFaqPid : "");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(magazine_detail_template/* NextNavigator */.j4, {
                                                        children: [
                                                            "다음 글",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                                name: "arrow_forward",
                                                                size: 16,
                                                                color: theme/* default.color.gray600 */.Z.color.gray600
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                viewModel.relatedFaq && viewModel.relatedFaq.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(related_magazine_list/* default */.Z, {
                                    totalRelatedMagazines: viewModel.relatedFaq,
                                    totalRelatedMagazinesTitle: "이런 콘텐츠는 어떠세요?",
                                    moveOtherMagazine: viewModel.moveOtherMagazine
                                }),
                                viewModel.faqRelatedQna && viewModel.faqRelatedQna.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_template/* Divider */.iz, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentRelatedQna/* default */.Z, {
                                            relatedQna: viewModel.faqRelatedQna,
                                            onClickRelatedQna: viewModel.onClickRelatedQna
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                            enabled: viewModel.isEnabledWebDiagnosisCategory,
                            params: {
                                eventName: diagnosis/* EWebTreatmentRequestLog.ClickWebDiagnosisToCategories */.o5.ClickWebDiagnosisToCategories,
                                payload: {
                                    inflowType: constants/* EWebDiagnosisInflowType.FaqDetail */.G0.FaqDetail
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_sticky_button, {
                                faq: viewModel.faq,
                                bottomButtonText: viewModel.bottomButtonText,
                                shouldShowEventText: viewModel.shouldShowEventText(),
                                onClickButton: viewModel.handleStickyButton
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var faq_detail_template = (FaqDetailTemplate);
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-bb06317e-0"
})(faq_detail_template_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI26SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray800;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI18M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray300;
});

// EXTERNAL MODULE: ./src/hooks/cuj/useAppInstallTopBanner.tsx
var useAppInstallTopBanner = __webpack_require__(40573);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/constants/logs/faq/index.ts
var logs_faq = __webpack_require__(4629);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/hooks/cuj/useAppDownloadCujModal.tsx + 1 modules
var useAppDownloadCujModal = __webpack_require__(11989);
// EXTERNAL MODULE: ./src/constants/common/index.ts
var constants_common = __webpack_require__(95611);
// EXTERNAL MODULE: ./src/hooks/magazine/magazine.gql.impl.tsx
var magazine_gql_impl = __webpack_require__(44355);
;// CONCATENATED MODULE: ./src/hooks/faq/useGetRelatedFaq.ts







var parseRelatedMagazines = function(data) {
    var parseMagazineListItem = function(magazine) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, magazine), {
            magazinePid: magazine.magazinePid,
            date: "".concat(dayjs_min_default()(magazine.createdAt).format("YYYY.MM.DD"))
        });
    };
    if (data) {
        return data.magazineRelatedMagazines.map(function(magazine) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parseMagazineListItem(magazine)), {
                contentType: magazine.contentType,
                isArticle: magazine.contentType === "ARTICLE"
            });
        });
    }
    return [];
};
var useGetRelatedFaq = function(faqPid) {
    var ref = (0,magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery */.yH)({
        request: {
            size: 4,
            magazinePid: faqPid
        }
    }, {
        select: parseRelatedMagazines,
        staleTime: constants_common/* SIX_HOURS_IN_MILLISECONDS */.At,
        cacheTime: constants_common/* SIX_HOURS_IN_MILLISECONDS */.At
    }), relatedFaq = ref.data;
    return {
        relatedFaq: relatedFaq
    };
};
/* harmony default export */ var faq_useGetRelatedFaq = (useGetRelatedFaq);
useGetRelatedFaq.getKey = function(faqPid) {
    return magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery.getKey */.yH.getKey({
        request: {
            size: 4,
            magazinePid: faqPid
        }
    });
};
useGetRelatedFaq.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, faqPid) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery.getKey */.yH.getKey({
                            request: {
                                size: 4,
                                magazinePid: faqPid
                            }
                        }), magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery.fetcher */.yH.fetcher({
                            request: {
                                size: 4,
                                magazinePid: faqPid
                            }
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, faqPid) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/hooks/magazine/useGetMagazineDetail.ts
var useGetMagazineDetail = __webpack_require__(6150);
// EXTERNAL MODULE: ./src/hooks/magazine/useGetPrevNextMagazinePid.ts
var useGetPrevNextMagazinePid = __webpack_require__(54110);
// EXTERNAL MODULE: ./src/hooks/qna/mobile/write/useCanProgressQnaWrite.tsx
var useCanProgressQnaWrite = __webpack_require__(61842);
// EXTERNAL MODULE: ./src/hooks/qna/useGetMagazineRelatedQna.ts
var useGetMagazineRelatedQna = __webpack_require__(35640);
// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/hooks/useClickContentLike.ts
var useClickContentLike = __webpack_require__(5872);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useMoveToHospitalSearch.ts
var useMoveToHospitalSearch = __webpack_require__(17440);
// EXTERNAL MODULE: ./src/hooks/useMoveToTotalSearch.ts
var useMoveToTotalSearch = __webpack_require__(23483);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(95613);
// EXTERNAL MODULE: ./src/shared/types/index.ts + 1 modules
var types = __webpack_require__(9628);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
;// CONCATENATED MODULE: ./src/hooks/faq/useFaqDetailViewModel.ts





























var useFaqDetailViewModel = function(param) {
    var faqPid = param.faqPid, client = param.client;
    var ref, ref1;
    var faq = (0,useGetMagazineDetail/* default */.Z)(faqPid);
    var moveToHospital = (0,useMoveToHospitalSearch/* default */.Z)().moveToHospital;
    var moveToTotalSearch = (0,useMoveToTotalSearch/* default */.Z)().moveToTotalSearch;
    var ref2 = (0,useCustomRouter/* default */.Z)(), moveToPage = ref2.moveToPage, router = ref2.router;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var showToast = (0,useToast/* default */.Z)().showToast;
    var clickProgressWrite = (0,useCanProgressQnaWrite/* default */.Z)().clickProgressWrite;
    var setShowAuthModal = (0,useAuthModal/* default */.Z)(true).setShowAuthModal;
    var ref3 = (0,useClickContentLike/* default */.Z)(faqPid), likeContent = ref3.likeContent, cancelLikeContent = ref3.cancelLikeContent;
    var relatedFaq = faq_useGetRelatedFaq(faqPid).relatedFaq;
    var ref4 = (0,useGetPrevNextMagazinePid/* default */.Z)(faqPid, magazine/* MagazineType.FAQ */.rL.FAQ), prevFaqPid = ref4.prevMagazinePid, nextFaqPid = ref4.nextMagazinePid;
    var ref5 = (0,useGetMagazineRelatedQna/* default */.Z)(faqPid), faqRelatedQna = ref5.magazineRelatedQna;
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)();
    var navigate = (0,useNavigate/* default */.Z)();
    var pageName = !(0,RNPlugins/* isWebView */.vp)() ? common/* ROUTES.FAQ.DETAIL.pageName */.Z6.FAQ.DETAIL.pageName : (0,logger/* getMobileWebPageName */.b9)(router);
    var copyUrl = (0,react.useMemo)(function() {
        return "".concat("https://doctornow.co.kr").concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faq === null || faq === void 0 ? void 0 : faq.magazinePid);
    }, [
        faq === null || faq === void 0 ? void 0 : faq.magazinePid
    ]);
    var title = (0,react.useMemo)(function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            return faq === null || faq === void 0 ? void 0 : faq.mobileTitle;
        }
        return faq === null || faq === void 0 ? void 0 : faq.title;
    }, [
        faq === null || faq === void 0 ? void 0 : faq.mobileTitle,
        faq === null || faq === void 0 ? void 0 : faq.title
    ]);
    var description = (0,react.useMemo)(function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            return faq === null || faq === void 0 ? void 0 : faq.mobileDescription;
        }
        return faq === null || faq === void 0 ? void 0 : faq.description;
    }, [
        faq === null || faq === void 0 ? void 0 : faq.mobileDescription,
        faq === null || faq === void 0 ? void 0 : faq.description
    ]);
    var faqContent = (0,react.useMemo)(function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            return faq === null || faq === void 0 ? void 0 : faq.mobileContent;
        }
        return faq === null || faq === void 0 ? void 0 : faq.content;
    }, [
        faq === null || faq === void 0 ? void 0 : faq.content,
        faq === null || faq === void 0 ? void 0 : faq.mobileContent
    ]);
    var departmentTags = (0,react.useMemo)(function() {
        return faq === null || faq === void 0 ? void 0 : faq.tags.filter(function(tag) {
            return tag.tagType === magazine/* MagazineTagType.DEPARTMENT */.Zg.DEPARTMENT;
        });
    }, [
        faq === null || faq === void 0 ? void 0 : faq.tags
    ]);
    var diseaseTags = (0,react.useMemo)(function() {
        return faq === null || faq === void 0 ? void 0 : faq.tags.filter(function(tag) {
            return tag.tagType === magazine/* MagazineTagType.DISEASE */.Zg.DISEASE;
        });
    }, [
        faq === null || faq === void 0 ? void 0 : faq.tags
    ]);
    var symptomTags = (0,react.useMemo)(function() {
        return faq === null || faq === void 0 ? void 0 : faq.tags.filter(function(tag) {
            return tag.tagType === magazine/* MagazineTagType.SYMPTOM */.Zg.SYMPTOM;
        });
    }, [
        faq === null || faq === void 0 ? void 0 : faq.tags
    ]);
    var faqTagNames = (0,react.useMemo)(function() {
        return faq && faq.tagNames ? faq.tagNames.map(function(name) {
            return name;
        }) : [];
    }, [
        faq
    ]);
    var bottomButtonText = (0,react.useMemo)(function() {
        switch(faq === null || faq === void 0 ? void 0 : faq.bottomButtonType){
            case magazine/* MagazineBottomButtonType.DIAGNOSIS */.wK.DIAGNOSIS:
                return "비대면 진료 받으러 가기";
            case magazine/* MagazineBottomButtonType.QUESTION */.wK.QUESTION:
            default:
                return "지금 바로 의료 상담받기";
        }
    }, [
        faq === null || faq === void 0 ? void 0 : faq.bottomButtonType,
        client.isWebView
    ]);
    var shouldShowEventText = function() {
        return !(0,RNPlugins/* isWebView */.vp)();
    };
    var airbridgeLinkOptions = {
        sub_id: faq === null || faq === void 0 ? void 0 : faq.magazinePid,
        sub_id_1: faq === null || faq === void 0 ? void 0 : faq.title,
        sub_id_2: (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) || "",
        sub_id_3: (departmentTags === null || departmentTags === void 0 ? void 0 : (ref1 = departmentTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
    };
    var getAirbridgeDynamicLink = function(options) {
        var linkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridgeDynamicLink.getDynamicLink(options, linkType);
    };
    var bottomButtonDynamicLink = function() {
        var ref, ref1;
        airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, {
            campaign: "web_content_faq",
            content: "web_content_flt_details",
            term: bottomButtonText,
            sub_id: faq === null || faq === void 0 ? void 0 : faq.magazinePid,
            sub_id_1: faq === null || faq === void 0 ? void 0 : faq.title,
            sub_id_2: (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) || "",
            sub_id_3: (departmentTags === null || departmentTags === void 0 ? void 0 : (ref1 = departmentTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
        });
    };
    var magazineTocLogger = function() {
        (0,logger/* magazineLogger */.Uj)({
            eventName: logs_faq/* FAQ_LOG_EVENT.CLICK_FAQ_TOC */.M.CLICK_FAQ_TOC,
            pageName: (0,logger/* getPageName */.j0)(router),
            payload: {
                id: faqPid
            }
        });
    };
    var extractTextFromChildren = function(children) {
        if (typeof children === "string") {
            return children;
        }
        if (typeof children === "number") {
            return String(children);
        }
        if (Array.isArray(children)) {
            return children.map(extractTextFromChildren).join("");
        }
        if (react.isValidElement(children) && children.props && children.props.children) {
            return extractTextFromChildren(children.props.children);
        }
        return "";
    };
    var onClickTag = function(tagName) {
        (0,logger/* faqLogger */.lp)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: logs_faq/* FAQ_LOG_EVENT.CLICK_FAQ_TAG */.M.CLICK_FAQ_TAG,
            payload: {
                faqPid: faqPid,
                tagType: magazine/* MagazineTagType.FREE */.Zg.FREE,
                tagName: tagName
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.FAQ.TAG.path */.Z6.FAQ.TAG.path, "?tag=").concat(tagName),
            mobileScreenName: common/* ROUTES.FAQ.TAG.appScreenName */.Z6.FAQ.TAG.appScreenName,
            params: {
                tag: tagName
            }
        });
    };
    var handleLikeClick = (0,react.useCallback)(function() {
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "faq_content_detail_".concat((faq === null || faq === void 0 ? void 0 : faq.isLikedByMe) ? "disLike" : "like", "_button_click"),
                pageName: pageName
            }
        });
        if (faq === null || faq === void 0 ? void 0 : faq.isLikedByMe) {
            cancelLikeContent();
            return;
        }
        likeContent();
    }, [
        cancelLikeContent,
        likeContent,
        faq === null || faq === void 0 ? void 0 : faq.isLikedByMe,
        pageName
    ]);
    var onClickLike = function() {
        if (!token) {
            showToast({
                message: "로그인 후 이용할 수 있어요."
            });
            setShowAuthModal(true);
            return;
        }
        handleLikeClick();
    };
    var onClickShare = function() {
        (0,logger/* logger */.kg)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: logs_faq/* FAQ_LOG_EVENT.UPPER_FAQ_SHARE_CLICK */.M.UPPER_FAQ_SHARE_CLICK
        });
    };
    var onRecordLog = function(logName) {
        (0,logger/* logger */.kg)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: logName
        });
    };
    var handleStickyButton = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,logger/* faqLogger */.lp)({
                            eventName: logs_faq/* FAQ_LOG_EVENT.DETAIL_STICKY_BUTTON_CLICK */.M.DETAIL_STICKY_BUTTON_CLICK,
                            pageName: (0,logger/* getPageName */.j0)(router),
                            payload: {
                                id: faqPid,
                                type: (faq === null || faq === void 0 ? void 0 : faq.bottomButtonType) || "",
                                platform: client.clientType
                            }
                        });
                        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.BottomCtaClick */.$.BottomCtaClick, (0,_object_spread/* default */.Z)({}, (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) && {
                            disease: diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref1 = diseaseTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name
                        }, (departmentTags === null || departmentTags === void 0 ? void 0 : (ref2 = departmentTags[0]) === null || ref2 === void 0 ? void 0 : ref2.name) && {
                            subject: departmentTags === null || departmentTags === void 0 ? void 0 : (ref3 = departmentTags[0]) === null || ref3 === void 0 ? void 0 : ref3.name
                        }, (symptomTags === null || symptomTags === void 0 ? void 0 : (ref4 = symptomTags[0]) === null || ref4 === void 0 ? void 0 : ref4.name) && {
                            symptom: symptomTags === null || symptomTags === void 0 ? void 0 : (ref5 = symptomTags[0]) === null || ref5 === void 0 ? void 0 : ref5.name
                        }));
                        _ = faq === null || faq === void 0 ? void 0 : faq.bottomButtonType;
                        switch(_){
                            case magazine/* MagazineBottomButtonType.DIAGNOSIS */.wK.DIAGNOSIS:
                                return [
                                    3,
                                    1
                                ];
                            case magazine/* MagazineBottomButtonType.QUESTION */.wK.QUESTION:
                                return [
                                    3,
                                    2
                                ];
                        }
                        return [
                            3,
                            2
                        ];
                    case 1:
                        if (client.isWebView) {
                            navigate.navigateCategorySelectWithJumpToHomeTab();
                        } else {
                            navigate.navigateToTelemedicineCategoriesScreen();
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        if (!client.isWebView) {
                            bottomButtonDynamicLink();
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            clickProgressWrite()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleStickyButton() {
            return _ref.apply(this, arguments);
        };
    }();
    var moveOtherMagazine = function(magazine) {
        moveToPage({
            webLink: magazine.isArticle ? "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid) : "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(magazine.magazinePid),
            mobileScreenName: magazine.isArticle ? common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName : common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: magazine.magazinePid
            }
        });
    };
    var onClickRelatedQna = function(questionPid) {
        (0,logger/* faqLogger */.lp)({
            eventName: logs_faq/* FAQ_LOG_EVENT.FAQ_RELATED_QNA_CLICK */.M.FAQ_RELATED_QNA_CLICK,
            pageName: (0,logger/* getPageName */.j0)(router),
            payload: {
                faqPid: faqPid,
                questionPid: questionPid
            }
        });
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_TAB_HOME */.nn.MOVE_TO_TAB_HOME, {
                tabName: "QuickAnswerTab",
                screenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
                params: {
                    questionId: questionPid
                }
            });
        } else {
            router.push({
                pathname: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid)
            });
        }
    };
    var onClickPrevNextFaq = function(faqPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faqPid),
            mobileScreenName: common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: faqPid
            }
        });
    };
    var onClickOuterLinkWithLinkText = function(url) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            navigate.navigateToPureWebViewAppScreen({
                uri: url
            });
        }
    };
    var onClickTopCta = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.TopCtaClick */.$.TopCtaClick, (0,_object_spread/* default */.Z)({}, (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) && {
            disease: diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref1 = diseaseTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name
        }, (departmentTags === null || departmentTags === void 0 ? void 0 : (ref2 = departmentTags[0]) === null || ref2 === void 0 ? void 0 : ref2.name) && {
            subject: departmentTags === null || departmentTags === void 0 ? void 0 : (ref3 = departmentTags[0]) === null || ref3 === void 0 ? void 0 : ref3.name
        }, (symptomTags === null || symptomTags === void 0 ? void 0 : (ref4 = symptomTags[0]) === null || ref4 === void 0 ? void 0 : ref4.name) && {
            symptom: symptomTags === null || symptomTags === void 0 ? void 0 : (ref5 = symptomTags[0]) === null || ref5 === void 0 ? void 0 : ref5.name
        }));
    };
    var setIsCujModalTrackingInfo = (0,useAppDownloadCujModal/* default */.Z)().setIsCujModalTrackingInfo;
    var isEnabledWebDiagnosisCategory = (faq === null || faq === void 0 ? void 0 : faq.bottomButtonType) === magazine/* MagazineBottomButtonType.DIAGNOSIS */.wK.DIAGNOSIS && !client.isWebView;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        if (!faq) {
            return;
        }
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, (0,_object_spread/* default */.Z)({}, (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) && {
            disease: diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref1 = diseaseTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name
        }, (departmentTags === null || departmentTags === void 0 ? void 0 : (ref2 = departmentTags[0]) === null || ref2 === void 0 ? void 0 : ref2.name) && {
            subject: departmentTags === null || departmentTags === void 0 ? void 0 : (ref3 = departmentTags[0]) === null || ref3 === void 0 ? void 0 : ref3.name
        }, (symptomTags === null || symptomTags === void 0 ? void 0 : (ref4 = symptomTags[0]) === null || ref4 === void 0 ? void 0 : ref4.name) && {
            symptom: symptomTags === null || symptomTags === void 0 ? void 0 : (ref5 = symptomTags[0]) === null || ref5 === void 0 ? void 0 : ref5.name
        }));
        setIsCujModalTrackingInfo({
            campaignName: "web_content_faq",
            trackContent: "web_content_mdl_details",
            contentId: faq.magazinePid,
            contentTitle: faq.title,
            contentCategory: (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref6 = diseaseTags[0]) === null || ref6 === void 0 ? void 0 : ref6.name) || "",
            contentSubCategory: (departmentTags === null || departmentTags === void 0 ? void 0 : (ref7 = departmentTags[0]) === null || ref7 === void 0 ? void 0 : ref7.name) || ""
        });
    }, [
        faq
    ]);
    return {
        faq: faq,
        title: title !== null && title !== void 0 ? title : "",
        description: description !== null && description !== void 0 ? description : "",
        faqContent: faqContent !== null && faqContent !== void 0 ? faqContent : "",
        magazineTocLogger: magazineTocLogger,
        moveToHospital: moveToHospital,
        departmentTags: departmentTags !== null && departmentTags !== void 0 ? departmentTags : [],
        symptomTags: symptomTags !== null && symptomTags !== void 0 ? symptomTags : [],
        diseaseTags: diseaseTags !== null && diseaseTags !== void 0 ? diseaseTags : [],
        moveToTotalSearch: moveToTotalSearch,
        faqTagNames: faqTagNames,
        onClickTag: onClickTag,
        copyUrl: copyUrl,
        onClickLike: onClickLike,
        handleLikeClick: handleLikeClick,
        onClickShare: onClickShare,
        onRecordLog: onRecordLog,
        handleStickyButton: handleStickyButton,
        relatedFaq: relatedFaq,
        moveOtherMagazine: moveOtherMagazine,
        faqRelatedQna: faqRelatedQna,
        onClickRelatedQna: onClickRelatedQna,
        prevFaqPid: prevFaqPid,
        nextFaqPid: nextFaqPid,
        onClickPrevNextFaq: onClickPrevNextFaq,
        bottomButtonText: bottomButtonText,
        shouldShowEventText: shouldShowEventText,
        onClickTopCta: onClickTopCta,
        airbridgeLinkOptions: airbridgeLinkOptions,
        getAirbridgeDynamicLink: getAirbridgeDynamicLink,
        extractTextFromChildren: extractTextFromChildren,
        onClickOuterLinkWithLinkText: onClickOuterLinkWithLinkText,
        isEnabledWebDiagnosisCategory: isEnabledWebDiagnosisCategory
    };
};
/* harmony default export */ var faq_useFaqDetailViewModel = (useFaqDetailViewModel);

// EXTERNAL MODULE: ./src/shared/utils/format.ts
var utils_format = __webpack_require__(64214);
;// CONCATENATED MODULE: ./src/pages/content/faq/[id]/index.tsx
// PageDescription: FAQ 상세 페이지














var __N_SSP = true;
var createFaqLdJson = function(faq) {
    if (!faq) {
        return;
    }
    var author = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "@type": "Person",
        name: faq.author.name
    }, faq.author.profileDescription && {
        description: faq.author.profileDescription
    }), {
        jobTitle: (0,utils_format/* formatAuthorType */.m)(faq.author.authorType),
        url: "".concat("https://doctornow.co.kr", "/author/").concat(faq.author.authorPublicId),
        image: faq.author.profileImageUrl,
        affiliation: {
            "@type": "Organization",
            name: "닥터나우",
            url: "".concat("https://doctornow.co.kr")
        },
        alumniOf: faq.author.careers.map(function(career) {
            return {
                "@type": "Organization",
                name: career.content
            };
        })
    });
    var questionSchema = {
        "@type": "Question",
        "@id": "".concat("https://doctornow.co.kr", "/content/faq/").concat(faq.magazinePid, "#question"),
        name: faq.title,
        text: faq.description,
        dateCreated: dayjs_min_default()(faq.createdAt).format("YYYY-MM-DDTHH:mm:ss[Z]"),
        answerCount: 1,
        upvoteCount: faq.likeCount,
        author: author,
        acceptedAnswer: {
            "@type": "Answer",
            text: (0,format/* convertMarkdownToPlainText */.BN)(faq.content),
            dateCreated: dayjs_min_default()(faq.createdAt).format("YYYY-MM-DDTHH:mm:ss[Z]"),
            upvoteCount: faq.likeCount,
            url: "".concat("https://doctornow.co.kr", "/content/faq/").concat(faq.magazinePid),
            author: author
        }
    };
    return [
        {
            "@context": "https://schema.org",
            "@type": "QAPage",
            "@id": "".concat("https://doctornow.co.kr", "/content/faq/").concat(faq.magazinePid),
            mainEntity: questionSchema
        },
        {
            "@context": "https://schema.org",
            "@type": "MedicalWebPage",
            name: faq.title,
            description: faq.description,
            url: "".concat("https://doctornow.co.kr", "/content/faq/").concat(faq.magazinePid),
            author: author
        },
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "닥터나우",
            url: "".concat("https://doctornow.co.kr"),
            logo: "https://media.doctornow.co.kr/og-main.png",
            contactPoint: [
                {
                    "@type": "ContactPoint",
                    email: "contact@doctornow.co.kr",
                    contactType: "customer service"
                }, 
            ]
        }, 
    ];
};
var FaqDetail = function(param) {
    var id = param.id, client = param.client;
    var ref, ref1, ref2, ref3;
    var viewModel = faq_useFaqDetailViewModel({
        faqPid: id,
        client: client
    });
    var topBannerViewModel = (0,useAppInstallTopBanner/* default */.Z)();
    var ldJson = createFaqLdJson(viewModel.faq);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(ldJson !== null && ldJson !== void 0 ? ldJson : {})
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat((ref = viewModel.faq) === null || ref === void 0 ? void 0 : ref.title, " - 닥터나우"),
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(id),
                description: (ref1 = viewModel.faq) === null || ref1 === void 0 ? void 0 : ref1.description,
                openGraph: {
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(id),
                    title: ((ref2 = viewModel.faq) === null || ref2 === void 0 ? void 0 : ref2.title) || "",
                    description: ((ref3 = viewModel.faq) === null || ref3 === void 0 ? void 0 : ref3.description) || "",
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/og-magazine.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_detail_template, {
                viewModel: viewModel,
                topBannerViewModel: topBannerViewModel,
                client: client
            })
        ]
    });
};
FaqDetail.Layout = DefaultLayout/* default */.Z;
/* harmony default export */ var _id_ = (FaqDetail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2498,3609,9653,1743,4365,4429,2367,8648,8307,9774,2888,179], function() { return __webpack_exec__(34847); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);